<template>
  <div class="broker-select" v-if="options.length > 2">
    <p class="broker-select__title">
      {{ $t("select portfolio") }}
    </p>
    <fhs-select
      :options="options"
      :disabled="onLoading"
      @handleSelect="changeSelectedPortfolio"
      class="broker-select__select"
    />
  </div>
</template>
<script>
import SelectPrimary from "@/components/ui-kit/SelectPrimary";
import { mapGetters } from "vuex";
export default {
  props: {
    options: {
      type: Array,
      required: false,
      disabled: false
    }
  },
  components: {
    "fhs-select": SelectPrimary
  },
  computed: {
    ...mapGetters([
      "getPortfolioLoading",
      "isIncomeLoading",
      "getMoneyDataLoading"
    ]),
    onLoading() {
      return (
        this.getPortfolioLoading ||
        this.isIncomeLoading ||
        this.getMoneyDataLoading
      );
    }
  },
  methods: {
    changeSelectedPortfolio(portfolioId) {
      this.disabled = true;
      setTimeout(() => {});
      this.$store.dispatch("changeSelectedPortfolio", {
        portfolioId: portfolioId,
        route_name: this.$route.name
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.broker-select {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.broker-select__title {
  margin: 0 0 5px 4px;
  font-size: 13px;
  color: #acb5c5;
}

.broker-select__select {
  padding: 0;
  font-size: 12px;
  color: #ffffff;
  background-color: #384770;
  border: none;
  padding: 4px;
}

.broker-select__select:disabled {
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0.5;
}
</style>
